import React from "react";
import "../../styles/Pagination.css";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  setItemsPerPage: (value: number) => void;
  setCurrentPage: (value: number) => void;
  startIdx: number;
  endIdx: number;
  totalItems: number;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  setItemsPerPage,
  setCurrentPage,
  startIdx,
  endIdx,
  totalItems,
}) => (
  <div className="pagination-bar">
    <span className="pagination-label">Items per page:</span>
    <div className="pagination-select-wrapper">
      <select
        className="pagination-select"
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
      >
        {[10, 20, 50, 100].map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
      <svg
        className="pagination-select-arrow"
        width="18"
        height="18"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 8l4 4 4-4"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
    <span className="pagination-info">
      {startIdx + 1}-{Math.min(endIdx, totalItems)} of {totalItems} items
    </span>
    <button
      className="pagination-arrow-btn"
      onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
      disabled={currentPage === 1}
      aria-label="Previous page"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <button
      className="pagination-arrow-btn"
      onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
      disabled={currentPage === totalPages}
      aria-label="Next page"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
);

export default Pagination;
